export default __webpack_public_path__ + "static/sorakcc_map-e6f057f78fcd9b65ecb36fbd0dcdfed3.png";